module.exports = __webpack_public_path__ + "img/pic_06@2x_new.2678e46d.jpg";